
const API_URL = process.env.VUE_APP_API_URL+'/office'
const FOTO_URL = process.env.VUE_APP_FOTO_URL


import { userService } from './userServices.js';


export const imgApi = {
    getImgRiievo,
    formatFoto

};
function getImgRiievo(uid) {
    const sid = userService.getSessionId();
    const comune = userService.getStoreCurrentComune();
    const uniqueId = uid;

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, uniqueId })
    };


    return fetch(API_URL + '/rilievi/getFotoRilievo', requestOptions).then(userService.handleResponse)
        .then(ret => {
            if (ret) {
                const baseUrl = FOTO_URL
                // alert(' user service'+JSON.stringify(ret));
                //
                ret.forEach(element => {
                    element.url = baseUrl + element.hash
                });
                return ret;
            }
            return 'errore';
        });
}
function formatFoto(hashArray, fotoArray) {
    const baseUrl = FOTO_URL
    // alert(' user service'+JSON.stringify(ret));


    if (hashArray) {
        hashArray.forEach(element => {
            let foto = element;
            foto.url = baseUrl + element.hash
            fotoArray.push(foto);
        });
    }
}